import { forwardRef } from 'react';
import type { CSSProperties } from 'react';

type MarkingIconProps = { className?: string; style?: CSSProperties };

const BlockArrow = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M59.024 14.3095L45.6905 0.975966C45.0654 0.351055 44.2177 0 43.3338 0C42.45 0 41.6023 0.351055 40.9772 0.975966L13.3335 28.6196L5.69007 20.9762C5.22389 20.5102 4.63 20.1928 3.98349 20.0642C3.33697 19.9357 2.66685 20.0017 2.05784 20.2539C1.44884 20.5062 0.928287 20.9333 0.562001 21.4813C0.195716 22.0294 0.000140749 22.6737 0 23.3329V56.6666C0 57.5507 0.351193 58.3986 0.976322 59.0237C1.60145 59.6488 2.44931 60 3.33337 60H36.6671C37.3263 59.9999 37.9706 59.8043 38.5186 59.438C39.0667 59.0717 39.4938 58.5512 39.7461 57.9422C39.9983 57.3331 40.0643 56.663 39.9358 56.0165C39.8072 55.37 39.4898 54.7761 39.0238 54.3099L31.3804 46.6665L59.024 19.0228C59.6489 18.3977 60 17.55 60 16.6662C60 15.7823 59.6489 14.9346 59.024 14.3095ZM24.3103 44.3098C23.6854 44.9349 23.3343 45.7826 23.3343 46.6665C23.3343 47.5504 23.6854 48.3981 24.3103 49.0232L28.6203 53.3333H6.66675V31.3797L10.9768 35.6897C11.6019 36.3146 12.4496 36.6657 13.3335 36.6657C14.2174 36.6657 15.0651 36.3146 15.6902 35.6897L43.3338 8.04605L51.954 16.6662L24.3103 44.3098Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);

const BoldArrow = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.027 60V43.3333H60V16.6667L30.027 16.6667V0L-9.53674e-07 29.7967L30.027 60Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);

const RoundedArrow = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M58.1705 10.3031L20.4589 48.0147H29.9632C31.5525 48.0147 33.0768 48.6461 34.2006 49.7699C35.3244 50.8938 35.9558 52.418 35.9558 54.0074C35.9558 55.5967 35.3244 57.121 34.2006 58.2448C33.0768 59.3686 31.5525 60 29.9632 60H5.99264C4.40329 60 2.87904 59.3686 1.7552 58.2448C0.631366 57.121 0 55.5967 0 54.0074V30.0368C0 28.4475 0.631366 26.9232 1.7552 25.7994C2.87904 24.6755 4.40329 24.0442 5.99264 24.0442C7.58198 24.0442 9.10623 24.6755 10.2301 25.7994C11.3539 26.9232 11.9853 28.4475 11.9853 30.0368V39.5411L49.6969 1.82948C50.2497 1.25712 50.911 0.800591 51.6421 0.486523C52.3732 0.172455 53.1596 0.00714067 53.9553 0.000226264C54.751 -0.00668814 55.5401 0.144935 56.2766 0.44625C57.013 0.747565 57.6821 1.19254 58.2448 1.7552C58.8075 2.31787 59.2524 2.98696 59.5537 3.72343C59.8551 4.4599 60.0067 5.24901 59.9998 6.04471C59.9929 6.84041 59.8275 7.62676 59.5135 8.35789C59.1994 9.08901 58.7429 9.75027 58.1705 10.3031Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);

const ShortArrow = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.9113 4.87511L30.0431 0L0 30.0017L30.0431 60L34.9113 55.1249L13.2024 33.447H60V26.5564H13.199L34.9113 4.87511Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);

const NarrowArrow = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
      >
        <g clipPath="url(#clip0_2_3)">
          <path
            d="M60 2.68685L57.3132 0L3.7843 53.5478V29.7256H0V58.1079C0 58.6097 0.199351 59.091 0.554197 59.4458C0.909044 59.8007 1.39032 60 1.89215 60H32.1665V56.2157H6.45222L60 2.68685Z"
            fill="currentColor"
          />
        </g>
      </svg>
    );
  }
);

const Crescendo = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5_19)">
          <line
            x1="-6.13139"
            y1="29.7262"
            x2="71.8182"
            y2="11.7301"
            stroke="currentColor"
            strokeWidth="5"
          />
          <line
            x1="-5.13251"
            y1="29.4454"
            x2="73.3977"
            y2="44.7101"
            stroke="currentColor"
            strokeWidth="5"
          />
        </g>
      </svg>
    );
  }
);

const Decrescendo = forwardRef<SVGSVGElement, MarkingIconProps>(
  ({ className, style }, ref) => {
    return (
      <svg
        ref={ref}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5_51)">
          <line
            y1="-2.5"
            x2="80"
            y2="-2.5"
            transform="matrix(-0.97437 -0.224951 -0.224951 0.97437 65.6815 31.6749)"
            stroke="currentColor"
            strokeWidth="5"
          />
          <line
            y1="-2.5"
            x2="80"
            y2="-2.5"
            transform="matrix(-0.981627 0.190809 0.190809 0.981627 65.5141 31.4086)"
            stroke="currentColor"
            strokeWidth="5"
          />
        </g>
      </svg>
    );
  }
);

export {
  BlockArrow,
  ShortArrow,
  NarrowArrow,
  Crescendo,
  Decrescendo,
  RoundedArrow,
  BoldArrow,
};
